<template>
  <v-layout class="tile pa-2 my-1">
    <div v-if="checkable" class="checkaction">
      <input class="checkbox" type="checkbox" />
    </div>
    <v-flex class="middle-container" xs8>
      <div class="html-container">
        <div v-if="editable">
          <textarea :value="task.data.text" class="text-area" placeholder="Task Text" rows="2" />
        </div>
        <div v-else v-html="task.data.text" />
      </div>
      <div class="action-container">
        {{ task.data.author }}
      </div>
    </v-flex>
    <v-flex class="action-stack">
      <div class="stack-top time v-list__tile__sub-title">
        {{ task.updatedAt | time }}
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TaskListTile',
  filters: {
    time: function(a) {
      return moment(a).fromNow();
    }
  },
  props: {
    task: Object,
    editable: {
      type: Boolean,
      default: false
    },
    checkable: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.text-area {
  width: 100%;
}
</style>
